<template>
  <div class="out-search-container">
    <div
      class="search-container"
      :style="{ background: inputBgColor }"
      :class="{ round: shape === 'round', needFixed: isFixed }"
    >
      <input
        type="text"
        class="search-input"
        :placeholder="resolvedPlaceholder"
        v-model="searchValue"
        @keyup.enter="handleSearch"
      />
      <!-- 搜索 -->
      <button
        type="button"
        class="search-btn"
        :style="{
          backgroundColor: buttonBgColor,
          color: buttonTextColor,
        }"
        :aria-label="resolvedButtonText || $t('marketComponents.search')"
        @click="handleSearch"
      >
        <template v-if="resolvedButtonText">{{ resolvedButtonText }}</template>
        <svg v-else viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="7.25" />
          <path d="M15.8 15.8L21 21" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  props: {
    // 输入框提示文字
    placeholder: {
      type: String,
      default: null,
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: null,
    },
    // 搜索框整体背景色
    inputBgColor: {
      type: String,
      default: "#ffffff",
    },
    // 按钮背景色
    buttonBgColor: {
      type: String,
      default: "#409eff",
    },
    // 按钮文字颜色
    buttonTextColor: {
      type: String,
      default: "#ffffff",
    },
    shape: {
      type: String,
      default: "normal",
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  computed: {
    resolvedPlaceholder() {
      return this.placeholder === null
        // 请输入搜索内容
        ? this.$t("marketComponents.searchPlaceholder")
        : this.placeholder;
    },
    resolvedButtonText() {
      return this.buttonText === null
        // 搜索
        ? this.$t("marketComponents.search")
        : this.buttonText;
    },
  },
  methods: {
    // 处理搜索逻辑
    handleSearch() {
      // 将搜索值通过事件传递给父组件
      this.$emit("search", this.searchValue);
    },
  },
};
</script>

<style scoped lang="less">
.out-search-container.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  z-index: 999;
}
.search-container {
  display: flex;
  align-items: center;
  padding: 6px 7px;
  overflow: hidden;
  z-index: 99;
  margin-bottom: 8px;
}
.round {
  border-radius: 22px;
  .search-btn {
    border-radius: 103px;
  }
}
.search-container.needFixed {
  margin: 12px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0px 0px 8px 2px rgba(178, 181, 185, 0.25),
    inset 0px -20px 40px 0px rgba(255, 255, 255, 0.5),
    inset 0px 4px 15px 0px rgba(255, 255, 255, 0.3);
}

.search-input {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: none;
  outline: none;
  font-size: 14px;
  background-color: transparent;
}

.search-input::placeholder {
  color: #999;
}

.search-btn {
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 0 4px 4px 0;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  svg {
    display: block;
    width: 24px;
    height: 24px;
    stroke: currentColor;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

.search-btn:hover {
  opacity: 0.9;
}
</style>
